import { theme } from '@algoan/deep-dive/theme';
import styled from 'styled-components';

interface CircularProgressProps {
  numberPourcentage: number;
  backgroundColor?: string;
  color?: string;
  className?: string;
}

export const CircularProgressBar: React.FC<CircularProgressProps> = ({
  className,
  numberPourcentage,
  backgroundColor = theme.backgroundMenu,
  color = theme.bluePeps,
}) => {
  return (
    <S.Container className={className} backgroundColor={backgroundColor}>
      <S.CircularProgress numberPourcentage={numberPourcentage} backgroundColor={backgroundColor} color={color} />
    </S.Container>
  );
};

const S = {
  Container: styled.div<{ backgroundColor: string }>`
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${({ backgroundColor }) => backgroundColor};
  `,
  CircularProgress: styled.div<{ numberPourcentage: number; backgroundColor: string; color: string }>`
    position: relative;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.sweetGrey};
    display: flex;
    justify-content: center;
    align-items: center;

    ${({ numberPourcentage, color }) =>
      `background: conic-gradient(${color} 0%, ${color} ${numberPourcentage}%, transparent ${numberPourcentage}%, transparent 100%);`}

    &::after {
      content: '';
      position: absolute;
      width: 30px;
      height: 30px;
      background: red;
      border-radius: 50%;
      background-color: ${({ theme }) => theme.sweetGrey};

      ${({ theme, numberPourcentage, color }) =>
        `background: conic-gradient(${color} 0%, ${color} ${numberPourcentage}%, ${theme.sweetGrey} ${numberPourcentage}%, ${theme.sweetGrey} 100%);`}
    }

    &::before {
      content: '';
      position: absolute;
      width: 26px;
      height: 26px;
      background: ${({ backgroundColor }) => backgroundColor};
      border-radius: 50%;
      z-index: 10;
    }
  `,
};
